import styled from "styled-components";

export const Container = styled("div")<{ $backgroundImage: string }>`
	position: absolute;
	z-index: 1;
	top: -45px;
	right: -5px;
	width: 65px;
	height: 65px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	background-image: url(${({ $backgroundImage }) => $backgroundImage});
	background-size: cover;
	color: #fff;
	font-family: "Baloo";
	font-size: 16px;
	line-height: 82%;
	text-shadow: 2px 1px 0px #000;
	-webkit-text-stroke-width: 2px;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;

	animation: scalerotate 2s infinite;

	@keyframes scalerotate {
		0% {
			transform: scale(1) rotate(-30deg);
		}
		50% {
			transform: scale(1.2) rotate(-20deg);
		}
		100% {
			transform: scale(1) rotate(-30deg);
		}
	}
`;

export const Text = styled.span`
	margin-bottom: 5px;
	position: relative;

	span {
		position: absolute;
		opacity: 0;
		animation: fadeInText 4s infinite;
		width: max-content;
	}

	span.first-contribution-text {
		transform: translate(-50%, -95%);
	}

	span.first-contribution-sub-text {
		transform: translate(-50%, -5%);
		font-size: 9px;
	}

	span.first-contribution-bonus {
		transform: translate(-50%, -140%);
		font-size: 15px;
		animation-delay: 2s;
	}

	span.first-contribution-bonus-sub-text {
		transform: translate(-50%, -55%);
		font-size: 15px;
		animation-delay: 2s;
	}

	span.first-contribution-bonus-final-text {
		transform: translate(-50%, 35%);
		font-size: 9px;
		animation-delay: 2s;
	}

	@keyframes fadeInText {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 0;
		}
		75% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
`;
